import { useContext, useEffect, useState } from "react";
import ErrorIndicator from "../../../Components/ErrorIndicator";
import LoadingIndicator from "../../../Components/LoadingIndicator";
import { getRejectReadyAsync, sendMassReject } from "../../../services/adminService";
import { LoadingContext, LoadingContextType, ToastContext, ToastContextType, useAsync } from "../../../utilities/customHooks";
import Button, { ButtonProp } from "../../../Components/Button";
import Modal from "../../../Components/Modal";
import { useNavigate } from "react-router-dom";
import List from "../../../Components/List";

const RejectReady = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {showLoading, hideLoading} = useContext(LoadingContext) as LoadingContextType;
  const showToast = (useContext(ToastContext) as ToastContextType).showToast;
  const navigate = useNavigate();
  const [selectedUsers, setSelectedUsers] = useState<string[]>([])
  const [reloadOnSave, setReloadOnSave] = useState(false)

  const rejectReadyAsync = useAsync(() => getRejectReadyAsync(), [reloadOnSave]);

  if (rejectReadyAsync.status === "pending") {
    return <LoadingIndicator />;
  }
  
  if (rejectReadyAsync.status === "rejected") {
    return <ErrorIndicator />;
  }

  const rejectReadyArray = (rejectReadyAsync.value.rejectReadyArray)

  const columnHeaderData = [
    {
      header: "Application Date",
      key: "date",
    },
    {
      header: "Company",
      key: "companyName",
    },
    {
      header: "IP Expert",
      key: "ipeName",
    },
    {
      header: "Tier Recommended",
      key: "tier",
      sortOptions: ["2", "3", "Both 2 and 3"],
    }
  ];

  const emailArrayChange = (array: string[]) => {
    let ids: string[] = []
    array.forEach(string => {
      rejectReadyArray.forEach(obj => {
        if (obj.companyName === string) {
          ids.push(obj.appId);
        }
      });
    });
    setSelectedUsers(ids)
  }

  async function massReject () {
    
    showLoading();
    const response = await sendMassReject(selectedUsers);
    hideLoading();
    
    if (response.success) {
      showToast({
        toastType: "success",
        message: "Rejection Email Sent",
      });
      setReloadOnSave(!reloadOnSave)
    }

  }

  return (
    <div className="resourcesCont !top-0">
      <h1>Companies With Rejection Criteria Filled out</h1>
      <p className="mt-2">Please ensure criteria is correct before sending email</p>
        <div className="w-full mb-5 flex">
          <div className="flex justify-center items-center">
            <Button 
              buttonType="primary"
              buttonText="Send Rejection Email to Selected"
              disabled={!(selectedUsers.length > 0)}
              actionHandler={ () => {
                setIsModalOpen(true);
              }}
            />
          </div>
        </div>
        <div className="w-full flex flex-col overflow-y-auto">
          <List
            contentArray={rejectReadyArray}
            columnHeaderData={columnHeaderData}
            emailArrayChange={emailArrayChange}
            checkbox={true}
          />
        </div>        
        <Modal 
          isOpen={isModalOpen}
          closeModal={() => setIsModalOpen(false)}
          modalHeader={""}
          contentLabel=""
          modalHTML={
            <div className="flex flex-col gap-4">
              <p>Are you sure you would like to send a rejection email to the selected Companies?</p>
                <div className="flex gap-4">
                  <Button
                    actionHandler={() => massReject()}
                    buttonText="Confimr"
                  />
                  <Button
                    actionHandler={() => setIsModalOpen(false)}
                    buttonText="Cancel"
                    buttonType="danger"
                  />
                </div>
            </div>
          }
        />
      </div>
  )
}

export default RejectReady